// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__BWqNs","load2":"Spinner_load2__2gkgc"};